import React from 'react';
import dayjs from 'dayjs';
import { NumericalColumn, StringColumn, CustomColumn } from 'baseui/data-table';
import { Button, KIND } from 'baseui/button';
import { StyledLink } from 'baseui/link';

export const COL_NAMES = {
	referredUserName: 'refereeName',
	referredUserId: 'refereeId',
	signupTimestamp: 'createdOn',
	referralSuccessTimestamp: 'referralAppliedOn',
	referralAmountToRefree: 'refereeBonus',
	referralAmountToReferred: 'refererBonus'
};

export const columnConfigs = [
	StringColumn({
		title: 'Referred User name',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.referredUserName]
	}),
	CustomColumn({
		title: 'Referred user id',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.referredUserId] || 0,
		renderCell: (params: any) => {
			const { value } = params;

			const handleOnClick = (event: any) => {
				event.preventDefault();
				event.stopPropagation();
				const url = `/userProfile/home?uid=${value}`;
				window.open(url, '_blank');
			};

			return (
				<Button
					kind={KIND.tertiary}
					onClick={handleOnClick}
					overrides={{
						Root: {
							style: ({ $theme }) => ({
								color: $theme.colors.primaryA,
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<StyledLink>{value}</StyledLink>
				</Button>
			);
		}
	}),
	StringColumn({
		title: 'Signup timestamp',
		maxWidth: 300,
		mapDataToValue: (data: any) => dayjs(new Date(data[COL_NAMES.signupTimestamp])).format('DD-MM-YYYY hh:mm A')
	}),
	StringColumn({
		title: 'Referral Success timestamp',
		maxWidth: 300,
		mapDataToValue: (data: any) => dayjs(data[COL_NAMES.referralSuccessTimestamp]).format('DD-MM-YYYY hh:mm A')
	}),
	NumericalColumn({
		title: 'Referral amount to Refree (₹)',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.referralAmountToRefree] || 0
	}),
	NumericalColumn({
		title: 'Referral amount to Referred (₹)',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.referralAmountToReferred] || 0
	})
];

export const activeFilter = [
	{
		columnKey: 'Referred User name',
		filterLabel: 'Referred User name',
		filterValue: true
	}
];
